import React, { useEffect, useState, useRef } from "react";
// import "./PWAInstallModal.css";  // Uncomment and ensure this points to your CSS file

const PWAInstallModal = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [delayIndex, setDelayIndex] = useState(0);
  const timeoutRef = useRef(null);

  const delays = [1 * 60 * 1000, 2 * 60 * 1000, 3 * 60 * 1000, 5 * 60 * 1000]; // 1min, 2min, 3min, 5min

  useEffect(() => {
    // Clear timeout on unmount
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  useEffect(() => {
    // 🔹 Force modal open for local testing
    if (window.location.hostname === "localhost") {
      setShowModal(true);
    }

    // 🔹 Real install prompt listener
    const handler = (e) => {
      e.preventDefault(); // stop default banner
      setDeferredPrompt(e);
      setShowModal(true);
    };

    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) {
      alert(
        "This is just a preview (localhost). In production the browser prompt will appear."
      );
      setShowModal(false);
      return;
    }

    deferredPrompt.prompt(); // Show browser's native install popup
    const { outcome } = await deferredPrompt.userChoice;
    console.log("User choice:", outcome);

    if (outcome === "accepted") {
      console.log("✅ App installed!");
    } else {
      console.log("❌ Install dismissed");
    }

    setDeferredPrompt(null);
    setShowModal(false);
    // After install or dismiss, reset delay index to stop further nagging
    setDelayIndex(0);
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  };

  const handleClose = () => {
    setShowModal(false);

    // Schedule reshow only if deferredPrompt exists (or on localhost for testing)
    if (deferredPrompt || window.location.hostname === "localhost") {
      const delay =
        delayIndex < delays.length - 1
          ? delays[delayIndex]
          : delays[delays.length - 1]; // After 5min, always use 5min

      timeoutRef.current = setTimeout(() => {
        setShowModal(true);
      }, delay);

      setDelayIndex((prev) => prev + 1);
    }
  };

  if (!showModal) return null;

  return (
    <div className="pwa-modal-overlay">
      <div className="pwa-modal">
        <img
          src="/assets/images/logo/logo.png"
          alt="Install App"
          className="pwa-img"
        />
        <h2 className="pwa-title">💖 Install Our Dating App!</h2>
        <p className="pwa-text">
          {" "}
          Download our app now to explore exciting profiles, view exclusive
          photos, chat with other singles, and connect instantly! Stay updated,
          meet new people, and enjoy a seamless experience right from your home
          screen
        </p>
        <div className="pwa-actions">
          <button className="btn-install" onClick={handleInstall}>
            Install Now
          </button>
          <button className="btn-close" onClick={handleClose}>
            Later
          </button>
        </div>
      </div>
    </div>
  );
};

export default PWAInstallModal;
